import { IonCol, IonGrid, IonRow, isPlatform } from "@ionic/react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import React, {
  ChangeEvent,
  forwardRef,
  ReactNode,
  SetStateAction,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { GenerateGUID } from "../components/Common";

import api from "./../services/api";

// import { v4 as uuidv4, v4 } from "uuid";

type Props = {
  setPunishmentAddress?: React.Dispatch<React.SetStateAction<string>>;
  setPunishmentAddresses?: React.Dispatch<React.SetStateAction<string[]>>;
  options: string[];
  multiple?: boolean;
};

const PunishmentAddressAutocomplete: React.FC<Props> = ({
  setPunishmentAddress,
  setPunishmentAddresses,
  options,
  multiple = false,
}) => {
  const [open, setOpen] = React.useState(false);

  const loading = open && options.length === 0;

  return (
    <Autocomplete
      multiple={multiple}
      noOptionsText="Nie znaleziono"
      // id={v4()}
      sx={{
        width: {
          xs: "100%",
          sm: "100%",
          md: "auto",
        },
      }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => option === value}
      getOptionLabel={(option) => {
        return option;
      }}
      onChange={(event, value) => {
        if (setPunishmentAddress) {
          const val = value as string | null;
          setPunishmentAddress(val ?? "");
        }
        if (setPunishmentAddresses) {
          const val = value as string[] | null;
          setPunishmentAddresses(val ?? []);
        }
      }}
      options={options}
      loading={loading}
      renderInput={(params) => (
        <TextField
          variant="outlined"
          type={"search"}
          className="shadow-mui"
          {...params}
          id={GenerateGUID()}
          autoComplete={GenerateGUID()}
          label="Adres"
          InputProps={{
            ...params.InputProps,
            autoComplete: "off",
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default PunishmentAddressAutocomplete;
